export default __webpack_public_path__ + "static/media/tofes4_logo.f1078780.png";